type Job = { title: string; body: string; accent: string };

type Props = {
    heading: string;
    jobs: Job[];
};

// White full-bleed band explaining the "Plan / Navigate / Share" framing
// used by both navigation guides — three bordered cards, each with a
// colour-coded top border tying it to the matching stack column above.
export default function GuideThreeJobs({ heading, jobs }: Props) {
    return (
        <section className="gt-guide-jobs">
            <div className="gt-guide-jobs__inner">
                <h2 className="gt-guide-jobs__heading">{heading}</h2>
                <div className="gt-guide-jobs__grid">
                    {jobs.map((job) => (
                        <div
                            key={job.title}
                            className="gt-guide-jobs__card"
                            style={{ borderTopColor: job.accent }}
                        >
                            <h3 className="gt-guide-jobs__title">{job.title}</h3>
                            <p className="gt-guide-jobs__body">{job.body}</p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
